import { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import MemberAreaData from "./MemberAreaData";

import classes from './index.module.scss';

const MemberAreaTable = ({ company }) => {
  const [activeTab, setSelectedTab] = useState(0);
  const hasArchive = (company.productList || []).some((product) => (product.test_records || []).some((record) => !!record.isArchive && record.certification_program?.id === 2));

  const onTabSelected = (e, id) => {
    setSelectedTab(id);
  }

  if (!hasArchive) {
    return (
      <MemberAreaData company={company} />
    )
  }

  return (
    <>
      <Tabs value={activeTab} onChange={onTabSelected} className={classes.tabs}>
        <Tab label="Active" value={0}></Tab>
        <Tab label="Archive" value={1}></Tab>
      </Tabs>
        {
          activeTab === 0 && (
            <MemberAreaData company={company} />
          )
        }
        {
          activeTab === 1 && (
            <MemberAreaData company={company} isArchive={true} />
          )
        }
    </>
  );
}

export default MemberAreaTable;